var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.569 16.5H2.5A.5.5 0 0 1 2 16V7.5a.5.5 0 0 1 .5-.5H16a.5.5 0 0 1 .5.5v2.07a7.281 7.281 0 0 1 2 0V3a1 1 0 0 0-1-1H15a.25.25 0 0 1-.25-.25v-1a.75.75 0 1 0-1.5 0V4.5a.75.75 0 1 1-1.5 0v-2a.5.5 0 0 0-.5-.5H7a.25.25 0 0 1-.25-.25v-1a.75.75 0 0 0-1.5 0V4.5a.75.75 0 1 1-1.5 0v-2a.5.5 0 0 0-.5-.5H1a1 1 0 0 0-1 1v13.5a2 2 0 0 0 2 2h7.569a7.281 7.281 0 0 1 0-2z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 11a6.5 6.5 0 1 0 6.5 6.5 6.508 6.508 0 0 0-6.5-6.5zm.75 9a.75.75 0 1 1-1.5 0v-1.5a.25.25 0 0 0-.25-.25H15a.75.75 0 0 1 0-1.5h1.5a.25.25 0 0 0 .25-.25V15a.75.75 0 1 1 1.5 0v1.5a.25.25 0 0 0 .25.25H20a.75.75 0 0 1 0 1.5h-1.5a.25.25 0 0 0-.25.25z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarAdd);
export default __webpack_public_path__ + "static/media/calendar-add.ac96ffeb.svg";
export { ForwardRef as ReactComponent };